import { C } from "./const";

const IntroHero = () => {
    return (

        <section
            style={{
                background: `linear-gradient(135deg, #f0f7ff 0%, #e8f4fd 50%, #f5f0ff 100%)`,
                padding: "80px 24px 90px",
                position: "relative",
                overflow: "hidden",
            }}
        >
                     {/* subtle grid pattern */}
            <div
                style={{
                    position: "absolute",
                    inset: 0,
                    backgroundImage: `
        linear-gradient(rgba(59,130,246,0.04) 1px, transparent 1px),
        linear-gradient(90deg, rgba(59,130,246,0.04) 1px, transparent 1px)
      `,
                    backgroundSize: "48px 48px",
                    pointerEvents: "none",
                }}
            />

            <div
                className="hero-grid"
                style={{
                    maxWidth: 1200,
                    margin: "0 auto",
                    display: "grid",
                    gridTemplateColumns: "1fr 420px",
                    gap: 56,
                    alignItems: "center",
                    position: "relative",
                    zIndex: 1,
                }}
            >
                {/* Text */}
                <div>
                    <div
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 8,
                            background: "rgba(255,204,0,.15)",
                            border: "1px solid rgba(255,204,0,.35)",
                            color: C.gray,
                            padding: "6px 16px",
                            borderRadius: 20,
                            fontSize: 13,
                            fontWeight: 600,
                            marginBottom: 22,
                        }}
                    >
                        🏆 نمایندگی رسمی و معتمد بیمه پارسیان
                    </div>

                    <h1
                        style={{
                            color: C.neutral,
                            fontSize: "clamp(28px, 5vw, 46px)",
                            fontWeight: 900,
                            lineHeight: 1.45,
                            marginBottom: 20,
                        }}
                    >
                        آرامش واقعی با{" "}
                        <span style={{ color: C.accent }}>بیمه پارسیان</span>
                    </h1>

                    <p
                        style={{
                            color: C.neutral,
                            fontSize: 17,
                            lineHeight: 1.9,
                            marginBottom: 36,
                            maxWidth: 520,
                        }}
                    >
                        با بیش از ۱۳ سال تجربه در ارائه خدمات بیمه‌ای، ما در کنار شما
                        هستیم تا امنیت و آرامش را برای شما و خانواده‌تان به ارمغان
                        بیاوریم.
                    </p>

                    <div style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>
                        <a
                            href="#contact"
                            className="hov-btn"
                            style={{
                                background: C.accent,
                                color: C.primaryDark,
                                padding: "14px 32px",
                                borderRadius: 10,
                                fontWeight: 800,
                                fontSize: 16,
                            }}
                        >
                            دریافت مشاوره رایگان
                        </a>
                        <a
                            href="#services"
                            className="hov-btn"
                            style={{
                                background: "rgba(255,255,255,.12)",
                                color: C.neutral,
                                padding: "14px 32px",
                                borderRadius: 10,
                                fontWeight: 600,
                                fontSize: 16,
                                border: "1px solid rgba(255,255,255,.25)",
                                backdropFilter: "blur(8px)",
                            }}
                        >
                            مشاهده خدمات ↓
                        </a>
                    </div>

                    {/* trust badges */}
                    <div
                        style={{
                            display: "flex",
                            gap: 24,
                            marginTop: 40,
                            flexWrap: "wrap",
                        }}
                    >
                        {[
                            { icon: "✅", text: "مجوز رسمی بیمه مرکزی" },
                            { icon: "⚡", text: "پرداخت سریع خسارت" },
                            { icon: "🔒", text: "اطلاعات کاملاً محرمانه" },
                        ].map((b) => (
                            <div
                                key={b.text}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 7,
                                    color: C.neutral,
                                    fontSize: 13,
                                }}
                            >
                                <span>{b.icon}</span>
                                <span>{b.text}</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Visual card */}
                <div
                    className="hero-visual"
                    style={{
                        background: "rgba(255,255,255,.1)",
                        backdropFilter: "blur(20px)",
                        border: "2px solid rgb(255,255,255)",
                        borderRadius: 24,
                        padding: 36,
                        textAlign: "center",
                    }}
                >
                    <div style={{ fontSize: 72, marginBottom: 18 }}>🛡️</div>
                    <h3
                        style={{
                            color: C.neutral,
                            fontSize: 20,
                            fontWeight: 800,
                            marginBottom: 10,
                        }}
                    >
                        پوشش جامع بیمه‌ای
                    </h3>
                    <p
                        style={{
                            color: C.neutral,
                            fontSize: 14,
                            lineHeight: 1.7,
                            marginBottom: 26,
                        }}
                    >
                        از خودرو تا سلامت، از منزل تا سفر — همه چیز را پوشش می‌دهیم
                    </p>
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: 10,
                        }}
                    >
                        {["🚗 خودرو", "🏥 درمان", "🏠 آتش‌سوزی", "✈️ مسافرتی", "💼 عمر", "🏗️ مسئولیت"].map(
                            (item) => (
                                <div
                                    key={item}
                                    style={{
                                        background: "rgba(255,255,255,.14)",
                                        borderRadius: 8,
                                        padding: "9px 6px",
                                        color: C.neutral,
                                        fontSize: 13,
                                        fontWeight: 500,
                                    }}
                                >
                                    {item}
                                </div>
                            )
                        )}
                    </div>
                </div>
            </div>
        </section>

    );
}

export default IntroHero;